'use strict';

angular.module('itPurchasingControllers')

.controller('ItPurchasingAssignMultiSelectController', ['$scope', '$modal', 'growl', 'ITPurchasingService', 'searchService', function ($scope, $modal, growl, ITPurchasingService, searchService) {

    $scope.refreshEmployees = function (searchTerm) {
        if (searchTerm.length < 3) return;
        return searchService.searchActiveEmployees(searchTerm)
                            .then(function (employees) {
                                $scope.employees = employees;
                            });
    };

    $scope.multiSelectContainer.AssignToObject = {};

    /* Assign Employee */
    $scope.manageAssignSelected = function () {
        var assignModal = $modal({
            scope: $scope.$new(false),
            template: require('./itPurchasingAssignMultiSelect.tpl.html'),
            placement: 'center'
        });

        $scope.hideModal = function () {
            assignModal.$promise.then(assignModal.hide);
        };

        var updateSystemAndEmployee = function (systemAndEmployee, updatedRequest) {
            if (_.isUndefined(systemAndEmployee.AssignedTo)) {
                $scope.nbCards.NbToAssign -= 1;
                $scope.nbCards.NbToAuthorize += 1;
            }

            var updatedSysEmp = updatedRequest.SystemsAndEmployees[0];
            systemAndEmployee.AssignedTo = updatedSysEmp.AssignedTo;
            systemAndEmployee.AssignedToActiveDirectoryAccountUsername = updatedSysEmp.AssignedToActiveDirectoryAccountUsername;
            systemAndEmployee.AssignedToUrlImage = updatedSysEmp.AssignedToUrlImage;

            $scope.hideModal();
        };

        $scope.assignSelectedToMe = function () {
            _.forEach($scope.getSelectedSystemsAndEmployees(), function (systemAndEmployee) {
                ITPurchasingService
                    .assignToCurrentUser(systemAndEmployee)
                    .then(function (updatedRequest) {
                        updateSystemAndEmployee(systemAndEmployee, updatedRequest);
                    });
            });

        };

        $scope.assignSelectedToEmployee = function () {

            _.forEach($scope.getSelectedSystemsAndEmployees(), function (systemAndEmployee) {
                ITPurchasingService
                    .assignToEmployee(systemAndEmployee, $scope.multiSelectContainer.AssignToObject.EmployeeID)
                    .then(function (updatedRequest) {
                        updateSystemAndEmployee(systemAndEmployee, updatedRequest);
                    });
            });
        };
    }
}]);
